<template>
  <div>

    <el-checkbox :disabled="checkedReject || checkedInfo || checkedReview || checkedPending" v-model="checkedAccept">{{$t('users_tab_document_accept')}}</el-checkbox>
    <el-checkbox :disabled="checkedAccept || checkedInfo || checkedReview || checkedPending" v-model="checkedReject">{{$t('users_tab_document_reject')}}</el-checkbox>
    <el-checkbox :disabled="checkedAccept || checkedReject || checkedReview || checkedPending" v-model="checkedInfo">{{$t('users_tab_document_info')}}</el-checkbox>
    <el-checkbox :disabled="checkedAccept || checkedReject || checkedInfo || checkedPending" v-model="checkedReview">{{$t('users_tab_document_review')}}</el-checkbox>
    <el-checkbox :disabled="checkedAccept || checkedReject || checkedInfo || checkedReview" v-model="checkedPending">{{$t('users_tab_document_pending')}}</el-checkbox>

    <el-table
      :data="tableData"
      height="600px"
      style="width: 100%"
      @row-click="rowClick"
      :row-class-name="tableRowClassName">
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <!-- <el-table-column
        prop="userName"
        label="Name">
      </el-table-column> -->
      <!-- <el-table-column
        prop="taskName"
        label="Task Name">
      </el-table-column> -->
      <el-table-column
        :label="$t('users_tab_document_document')">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{$t('users_tab_document_type')}}: {{ scope.row.projectType }}</p>
            <p>{{$t('users_tab_document_name')}}: {{ scope.row.projectName }}</p>
            <p>{{$t('users_tab_document_taskName')}}: {{ scope.row.taskName }}</p>
            <div slot="reference" class="name-wrapper">
              <span size="medium" v-if="scope.row.docType === 'sop'">SOP</span>
              <span size="medium" v-else-if="scope.row.docType === 'healthsafety'">Health & Safety</span>
              <span size="medium" v-else>{{ capitalizeFirstLetter(scope.row.docType) }}</span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="docName"
        :label="$t('users_tab_document_documentName')">
      </el-table-column>
      <el-table-column
        :label="$t('users_tab_document_createDate')">
        <template slot-scope="scope">
          <span>{{scope.row.createDate ? moment(scope.row.createDate * 1000).format("D MMM YY") : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('users_tab_document_updateDate')">
        <template slot-scope="scope">
          <span>{{scope.row.lastUpdateDate ? moment(scope.row.lastUpdateDate * 1000).format("D MMM YY") : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('users_tab_document_status')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isAccepted" type="success">{{$t('users_tab_document_accepted')}}</el-tag>
          <el-tag v-if="scope.row.isRejected" @click="rejectMsg(scope.row.rejectMessage)" type="danger" style="cursor: pointer;">{{$t('users_tab_document_rejected')}}</el-tag>
          <el-tag v-if="scope.row.level == 0 && !scope.row.isAccepted && !scope.row.isRejected">{{$t('users_tab_document_info')}}</el-tag>
          <el-tag v-if="scope.row.level != 0 && !scope.row.isAccepted && !scope.row.isRejected && !scope.row.date" type="info">{{$t('users_tab_document_pending')}}</el-tag>
          <el-tag v-if="scope.row.level != 0 && !scope.row.isAccepted && !scope.row.isRejected && scope.row.date" type="info">{{$t('users_tab_document_review')}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <document-info-modal ref="documentInfoModal" :rejectMessage="rejectMessage"/>
  </div>
</template>

<script>
  import DocumentInfoModal from "../settings/documentManagment/documentModal/index";
  let moment = require('moment')
  import axios from 'axios'

  export default {
    components: {DocumentInfoModal},
    data() {
      return {
        moment:moment,

        tableData: [],

        checkedAccept: false,
        checkedReject: false,
        checkedInfo: false,
        checkedReview: false,
        checkedPending: false,
        // TODO: whatch
        checkedStatus: 0,
        rejectMessage: null
      }
    },
    watch: {
      checkedAccept(val) {
        if (val && !this.checkedReject && !this.checkedInfo && !this.checkedReview && !this.checkedPending) {
          this.checkedStatus = 1
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedReject(val) {
        if (val && !this.checkedAccept && !this.checkedInfo && !this.checkedReview && !this.checkedPending) {
          this.checkedStatus = 2
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedInfo(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedReview && !this.checkedPending) {
          this.checkedStatus = 3
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedReview(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedInfo && !this.checkedPending) {
          this.checkedStatus = 4
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedPending(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedInfo && !this.checkedReview) {
          this.checkedStatus = 5
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      usersId(val) {
        if (val == '') {
          this.usersId = null
        }

        this.loadList()
      },
    },
    created() {
      // this.loadList()
    },
    methods: {
      // * list
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/documentHistory/list?companyId=${this.$route.query.companyId}&userId=${this.$route.query.companyUserId}&statusId=${this.checkedStatus}&companyUserRequest=true`)
            .then(response => {
                let list = response.data.list
                for (let i = 0; i < list.length; i++) {
                  if (list[i].docType == 'riskassesment') {
                    list[i].docType = 'commercial'
                  }
                  if (list[i].docType == 'envirenmental') {
                    list[i].docType = 'general'
                  }
                }

                // this.tableData = response.data.list
                this.tableData = list
                loader.hide()
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
      },
      rowClick(row) {
        if (row.rejectMessage) {
          this.rejectMessage = row.rejectMessage
        } else {
          this.rejectMessage = null
        }
        // eslint-disable-next-line no-console
        this.$refs.documentInfoModal.openModal(row);
        console.log('---ROW', row);
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table-rows{
    cursor:pointer;
  }
</style>
